import React, { FC } from 'react';

import { observer } from 'mobx-react-lite';

import { glueName } from '@/shared/utils/users';
import { numWord } from '@/shared/utils/numWord';
import { IUser } from '@/entities/user/types';


interface RatingMeItemProps {
  place: number,
  user:IUser
}

export const RatingMeItem:FC<RatingMeItemProps> = observer(({place,user}) => {

  return (
    <div className='rating-me_item'>
      <p className='rating-me_number'>{place}</p>
      <div className='rating-me_user'>
        <img className='rating-me_icon' src={user.photoUrl} alt="icon" />
        <p className='rating-me_name'>{glueName(user)}</p>
      </div>
      <p className='rating-me_pucks'>{user.score + ' ' + numWord(user.score, ['шайба','шайбы','шайб']) }</p>
    </div>
  );

});